/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";
import { getFoodIcon } from "utils/foodIcons";
import SoftBadge from "components/SoftBadge";
import dayjs from "dayjs";

const getRows = (data, handleSelect, selectItem) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        producto: (
          <SoftBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            // onClick={() => handleSelect(item)}
          >
            <SoftTypography variant="caption">
              {item.productoNombre ?? "Sin producto"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidad: (
          <SoftBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            // onClick={() => handleSelect(item)}
          >
            {item.total ?? "Sin cantidad"}
          </SoftBox>
        ),
        estado: (
          <SoftBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            // onClick={() => handleSelect(item)}
          >
            <SoftBadge
              variant="color"
              color={
                item.estado === "CERRADO"
                  ? getUproColor("uproBlue")
                  : item.estado == "RESERVADO"
                  ? getUproColor("uproPink")
                  : getUproColor("uproGreen")
              }
              badgeContent={makeNiceText(item.estado)}
            />
          </SoftBox>
        ),
        actions: (
          <SoftBox display="flex" alignItems="center" justifyContent="space-between">
            <Tooltip title="Función en desarrollo, estará disponible en futuras versiones" placement="top">
              <Icon
                sx={{
                  cursor: "pointer",
                  color: getUproColor("primary"),
                }}
                fontSize="small"
                // onClick={() => handleSelect(item)}
              >
                visibility
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }
  return rows;
};

const columns = [
  { name: "producto", desc: "Producto", align: "left", noOrder: true },
  { name: "cantidad", desc: "Cantidad", align: "left", noOrder: true },
  { name: "estado", desc: "Estado", align: "left", noOrder: true },
  { name: "actions", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { getRows, columns };
